import Modal from "../../components/modal";

export default function SocialImpactPage() {
  return (
    <div
      className="hero pt-16"
      style={{
        backgroundImage: `url(https://static.igem.wiki/teams/4260/wiki/social-impact/social-impact-bg.png)`,
        minHeight: 200,
      }}
    >
      <div className="p-10 text-center">
        <h1
          className="text-7xl"
          style={{ fontFamily: "Cano", color: "rgb(248,255,152)" }}
        >
          Social Impact
        </h1>
        <div
          className="inline-block w-2/3 mt-6 text-white rounded-md"
          style={{
            backgroundColor: "rgba(255, 255,255,.1)",
            borderColor: "white",
            borderWidth: 1,
          }}
        >
          <p className="p-2" style={{ textAlign: "justify" }}>
            We decided to get out of the wet lab and the dry lab to get socially
            involved in the community in which we live in accordance with the
            sustainable development goals (SDG) such as forest reforestation or
            even inspiring students to become leaders of change for this decade
            of action of the 2030 agenda of the SDGs, as well as, recognize the
            stakeholders of our project in order to know the complete panorama
            of the problem through different perspectives in order to enrich our
            idea. For us it was of great importance to go, learn, ask and act to
            get involved in the reality of the problem we are facing. Finally we
            know that this competition would not be the same without being able
            to work and interact with other teams with whom we made alliances to
            help society and also fellowship just as we learned from them. “In
            technology, we spend so much time experimenting, fine-tuning,
            getting the absolute cheapest way to do something – so why aren’t we
            doing that with social policy?” — Esther Duflo
          </p>
        </div>
        <div className=" m-8">
          <img
            className="m-auto"
            src="https://static.igem.wiki/teams/4260/wiki/social-impact-venn-800.png"
            alt="Social Impact Venn diagram"
            usemap="#image-map"
            style={{ width: 800, minWidth: 800, maxWidth: 800 }}
          />
          <map name="image-map">
            <area
              target=""
              alt="Human Practices"
              title="Human Practices"
              href="/teccem/human-practices"
              coords="339,2,462,2,564,61,629,170,508,169,400,231,290,167,170,168,229,62"
              shape="poly"
            />
            <area
              target=""
              alt="Sustainability"
              title="Sustainability"
              href="sustainable"
              coords="630,170,737,229,796,334,798,457,737,563,630,619,628,499,567,397,630,292"
              shape="poly"
            />
            <area
              target=""
              alt="Collaborations"
              title="Collaborations"
              href="collaborations"
              coords="398,558,624,624,567,728,461,785,339,786,229,724,171,621,292,623"
              shape="poly"
            />
            <area
              target=""
              alt="Education and communication"
              title="Education and communication"
              href="communication"
              coords="168,168,169,294,231,393,171,499,169,619,59,559,0,456,-1,332,65,227"
              shape="poly"
            />
          </map>
        </div>
      </div>
    </div>
  );
}
